module.exports = __webpack_public_path__ + "static/media/matnrrd_2-437w.84e58668.png";